<template>
    <div>
        <div class="card-header">
            <h3>Text button widget</h3>
        </div>
        <form @submit.prevent="setBtn" id="form1" class="" >
            <div class="card-body">
                <div class="bgloading" v-show="isLoading" style="padding-top: 0;"><Loader></Loader></div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Name: </label>
                    <input
                        type="text"
                        class="form-control"
                        v-model="f.name"
                        required="true"
                    />
                </div>
            </div>
            <div class="card-footer d-flex justify-content-end">
                <button type="submit" class="btn btn-success btn-sm">SAVE</button>
            </div>
        </form>
    </div>
</template>

<script>
import Loader from "@/core/components/shared/Loader.vue";
export default {
  name: 'RoofCalBtnW',
  components: {
    Loader,
  },
  data() {
    return {
      user_id: window.master_client,
      org_id: window.localorgdata,
      isLoading: true,
      f: { 
        user_id: window.master_client,
        org_id: window.localorgdata,
        name: 'RoofCal Estimate',
      },
      apis: {},
    };
  },
  created() {
    let urlApis = this.$store.getters['ModApps/RoofCal/urlApis'];
    this.apis = urlApis.setup;
    this.getBtn();
  },
  methods: {
    getBtn(){
      let t = this;
      t.isLoading = true;
      window.master.post(this.apis.getBtn(), {
        user_id: window.master_client,
        org_id: window.localorgdata,
      })
      .then((response) => {
        if(response.data.status){
          t.f = response.data.r;
        }
        else{
          t.f.name = "RoofCal Estimate";
        }
        t.isLoading = false;
      })
      .catch((error) => {
        console.log(error);
        t.isLoading = false;
      });
    },
    setBtn(){
      let t = this;
      t.isLoading = true;
      window.master.post(this.apis.setBtn(), t.f)
      .then((response) => {
        t.getBtn();
      })
      .catch((error) => {
        console.log(error);
        t.isLoading = false;
      });
    },
    resetForm(){
      this.f.id = 0;
      this.f.name = '';
      this.f.email = '';
    },
  }

};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
